import React from 'react';
import { AuthForm } from './AuthForm';
import './AuthModal.css';

export interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLogin?: (email: string, password: string) => Promise<void>;
  onRegister?: (email: string, password: string, firstName: string, lastName: string) => Promise<{ needsVerification?: boolean; redirectToLogin?: boolean; userExists?: boolean; isVerified?: boolean } | void>;
  onLoginSuccess?: (token?: string, profile?: any) => void;
  onRegisterSuccess?: (token?: string, profile?: any) => void;
  onLoadingChange?: (loading: boolean) => void;
  initialTab?: 'login' | 'register';
}

export const AuthModal: React.FC<AuthModalProps> = ({
  isOpen,
  onClose,
  onLogin,
  onRegister,
  onLoginSuccess,
  onRegisterSuccess,
  onLoadingChange,
  initialTab = 'login',
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  return (
    <div
      className="auth-modal-overlay"
      onClick={handleBackdropClick}
      onKeyDown={handleKeyDown}
      role="dialog"
      aria-modal="true"
      aria-labelledby="auth-modal-title"
      tabIndex={-1}
    >
      <div className="auth-modal-content">
        <button
          className="auth-modal-close"
          onClick={onClose}
          aria-label="Close login modal"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        
        <div className="auth-modal-body">
          <div className="auth-modal-form-section">
            <h2 id="auth-modal-title" className="auth-modal-title">Welcome to Kairos</h2>
            <p className="auth-modal-subtitle">Sign in to your account or create a new one</p>
            <AuthForm
              showHeader={false}
              compact={false}
              onLoadingChange={onLoadingChange}
              onLogin={onLogin}
              onRegister={onRegister}
              initialTab={initialTab}
              onLoginSuccess={(token, profile) => {
                onLoginSuccess?.(token, profile);
                onClose();
              }}
              onRegisterSuccess={(token, profile) => {
                onRegisterSuccess?.(token, profile);
                onClose();
              }}
            />
          </div>
          <div className="auth-modal-visual-section">
            <div className="auth-modal-visual-content">
              <h2>Transform Your Career</h2>
              <p>AI-powered job matching and resume analysis to help you land your dream job faster.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
